import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
const FeatureController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FeatureController.url(options),
    method: 'get',
})

FeatureController.definition = {
    methods: ["get","head"],
    url: '/api/features',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
FeatureController.url = (options?: RouteQueryOptions) => {
    return FeatureController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
FeatureController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FeatureController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FeatureController::__invoke
* @see app/Http/Controllers/FeatureController.php:9
* @route '/api/features'
*/
FeatureController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FeatureController.url(options),
    method: 'head',
})

export default FeatureController